<template>
    <v-container fluid>
        <br>
        <h1 class="text-center" style="font-family: Avenir1;"> Accredited Partners </h1>
        <br>
        <v-row class="mt-5" justify="center" :style="$vuetify.breakpoint.width < 750 ? 'display: block;' : ''">
            <v-col align="center">
                <a href="https://dashwaste.co.za/" target="_blank" ref='noopener noreferral' :class="{'mt-12': !$vuetify.breakpoint.smAndDown}"> 
                    <v-img
                    class="img1 mt-5"
                    src="@/assets/logo.png"
                    alt="Logo"
                    width="230"
                    contain
                    />
                </a>
                <br/>
                <!-- <p class="main--text text-justify-center par"> Dash Waste </p> -->
            </v-col>
            <v-col align="center">
                <a href="https://umthi.africa/" target="_blank" ref='noopener noreferral'>
                    <v-img
                    class="img2"
                    src="@/assets/Umthi.png"
                    alt="Logo"
                    width="100"
                    contain
                    />
                </a>
                <br/>
                <!-- <p class="main--text text-justify-center par"> Umthi Initiatives since 2020 </p> -->
            </v-col>
            <v-col align="center">
                <a href="https://www.zeegroup.co.za/home" target="_blank" ref='noopener noreferral'>
                    <v-img
                    class="img3"
                    src="@/assets/Zeelogo.png"
                    alt="Logo"
                    width="65"
                    contain
                    />
                </a>
                <br/>
                <!-- <p class="main--text text-justify-center par"> Peach Payments gateaway since 2007 </p> -->
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'Partners',
    data() {
       return {

       }
    },
}
</script>
<style scoped>
.img1:hover {
    width: 45% !important;
}
.img2:hover {
    width: 20% !important;
}
.img3:hover {
    width: 13% !important;
}
</style>
